@if (business) {
  <div class="tud-card">
    <div class="ps-2 pe-2">
      <div class="row">
        <div class="col-sm-3"><strong>{{ 'content.business-name' | translate }}</strong></div>
        <div class="col-sm-3"><strong>{{ 'content.address.street-address' | translate }}</strong></div>
        <div class="col-sm-2"><strong>{{ 'content.address.postal-code' | translate }}</strong></div>
        <div class="col-sm-2"><strong>{{ 'content.phone.phone' | translate }}</strong></div>
        <div class="col-sm-2"><strong>{{ 'content.person.owner-name' | translate }}</strong></div>
      </div>
      <div>
        <div class="row">
          <div class="col-sm-3">
            <ul>
              @for (name of business.names; track name) {
                <li>{{ name }}</li>
              }
            </ul>
          </div>
          <div class="col-sm-3">
            <ul>
              @for (street of business.streets; track street) {
                <li>{{ street }}</li>
              }
            </ul>
          </div>
          <div class="col-sm-2">
            <ul>
              @for (postal of business.postals; track postal) {
                <li>{{ postal }}</li>
              }
            </ul>
          </div>
          <div class="col-sm-2">
            <ul>
              @for (phone of business.phones; track phone) {
                <li>{{ phone }}</li>
              }
            </ul>
          </div>
          <div class="col-sm-2">{{ business.ownername }}</div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center inline-gap-10 pt-2">
      @if (mapEnabled && !isMapShowing) {
        <button class="tu-link" (click)="showMap()">{{ 'content.search-result.view-map' | translate }}</button>
      }
      @if (mapEnabled && isMapShowing) {
        <button class="tu-link" (click)="hideMap()">{{ 'content.search-result.hide-map' | translate }}</button>
      }
      <a class="tu-link ms-2" routerLink="/business-services/credit-report" [attr.aria-label]="'content.pull-report-for-data' | translate" [state]="businessRequest">
        {{ 'content.search-result.pull-report' | translate }}
      </a>
    </div>
    @if (mapEnabled && isMapShowing) {
      <div>
        @if (loading) {
          <div>{{ 'content.loading' | translate }}</div>
        }
        @if (!loading && geocodeSuccess) {
          <div class="w-100 pt-2">
            <google-map [options]="options" width="100%">
              <map-marker [position]="markerPosition" [options]="markerOptions"></map-marker>
            </google-map>
          </div>
        }
        @if (!loading && !geocodeSuccess) {
          <div>{{ 'content.search-result.no-map' | translate }}</div>
        }
      </div>
    }
  </div>
}

